/**
 * CertificationDetail
 * Functionality for certification detail page
 */
export default class CertificationDetail {

    // constructor
    constructor(selector) {

        let _this = this;
        this.$plugin = $(selector);

        // cancel if non existing element
        if (this.$plugin.length === 0) {
            return false;
        }
        this.initialLoad();

        window.addEventListener("router", function (e) {
            _this.changeTab();
        });
        _this.switchAudits();
        _this.switchContactPerson();
    }



    /**
	 * this script is loaded on pageload
	 * to get information like title
     */
    initialLoad() {
    	let vm = this;
        let $dynamicElement = this.$plugin.find('[data-tncp-tabs-content-id="0"] [data-tncp-xhr]');
        window.xhrRequest({
            url: $dynamicElement.data('tncp-xhr')
        }).then((response) => {
            vm.$plugin.find('[data-tncp-certificationDetail-title]').html(response.data.title);
        });
    }


    /**
     * This function is called on tab change by router event
     */
    changeTab() {
        let vm = this;
        vm.loadData();
    }

    /**
     * @param routeId
     */
    loadData(routeId = '') {
        let vm = this;
        if (routeId === '') {
            routeId = window.tncpRouter.getRoute();
        }
        let $dynamicElement = this.$plugin.find('[data-tncp-tabs-content-id="' + routeId + '"] [data-tncp-xhr]');
        let xhrPath = $dynamicElement.data('tncp-xhr');
        vm.request = window.xhrRequest({
            url: xhrPath
        }).then((response) => {
            $dynamicElement.html(response.data.content);

            $('.js-popup-link--inline').magnificPopup({
                type:'inline',
                midClick: true
            });
        });
    }


    switchAudits() {
        let vm = this;
        vm.$plugin.on('click', '[data-tncp-plugin-certificationDetail-auditswitch]', function (event) {
            let auditId = $(this).attr('data-tncp-plugin-certificationDetail-auditswitch');

            vm.$plugin.find('[data-tncp-plugin-certificationDetail-auditswitch]').addClass('c-button--fill');
            vm.$plugin.find('[data-tncp-plugin-certificationDetail-auditswitch]').removeClass('c-button--primary');
            $(this).removeClass('c-button--fill');
            $(this).addClass('c-button--primary');

            vm.$plugin.find('[data-tncp-plugin-certificationDetail-audit]').hide();
            vm.$plugin.find('[data-tncp-plugin-certificationDetail-audit="' + auditId + '"]').show();
            event.preventDefault();
        });
    }

    switchContactPerson() {
        let vm = this;
        vm.$plugin.on('click', '[data-tncp-plugin-certificationDetail-showperson]', function (event) {
            let personId = $(this).attr('data-tncp-plugin-certificationDetail-showperson');

            vm.$plugin.find('[data-tncp-plugin-certificationDetail-person]').removeClass('c-processoverview__contactperson--show');
            vm.$plugin.find('[data-tncp-plugin-certificationDetail-person="' + personId + '"]').addClass('c-processoverview__contactperson--show');
            event.preventDefault();
        });
    }
}